// extracted by mini-css-extract-plugin
export default {"root":"CreditNotesList_root__1EJIl"};